function createCalendar() {
    const monthEl = document.getElementById("month");
    const tbody = document.getElementById("calendar-body");

    if (!monthEl || !tbody) {
        return;
    }

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    const monthNames = [
        "Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.",
        "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
    ];

    const specialDays = {
        1: [6, 13, 20, 27],
        2: [3, 10, 17, 24],
        3: [3, 10, 17, 24, 31],
        4: [1, 7, 8, 14, 15, 21, 22, 28, 29],
        5: [4, 7, 13, 14, 20, 21, 23, 24, 27, 28],
        6: [3, 4, 10, 17, 18, 24, 25, 27, 28],
        7: [1, 7, 8, 14, 15, 22, 29],
        8: [5, 6, 12, 13, 19, 20, 25, 26],
        9: [2, 9, 10, 16, 17, 23, 24, 26, 27, 30],
        10: [1, 7, 14, 15, 18, 21, 28, 29],
        11: [4, 5, 11, 12, 18, 19, 25, 26],
        12: [2, 3, 9, 10, 16, 17, 23, 24, 30, 31]
    };

    const currentMonthSpecialDays = specialDays[month + 1] || [];

    monthEl.textContent = `${monthNames[month]} / ${year}`;

    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();

    tbody.innerHTML = "";

    let row = document.createElement("tr");

    for (let i = 0; i < firstDay; i++) {
        row.appendChild(document.createElement("td"));
    }

    for (let day = 1; day <= lastDate; day++) {
        const cell = document.createElement("td");
        cell.textContent = day;

        const dayOfWeek = new Date(year, month, day).getDay();

        if (dayOfWeek === 0) cell.classList.add("sun");
        if (dayOfWeek === 6) cell.classList.add("sat");
        if (currentMonthSpecialDays.includes(day)) {
            cell.classList.add("special");
        }

        row.appendChild(cell);

        if (dayOfWeek === 6) {
            tbody.appendChild(row);
            row = document.createElement("tr");
        }
    }

    if (row.children.length > 0) {
        while (row.children.length < 7) {
            row.appendChild(document.createElement("td"));
        }
        tbody.appendChild(row);
    }
}

function initCalendar() {
    createCalendar();
}

document.addEventListener("DOMContentLoaded", initCalendar);
document.addEventListener("shopify:section:load", initCalendar);
